import React from 'react';

import {ResponsiveElementGroup} from 'src/components/responsive-element-group';
import {SkeletonItem} from 'src/components/skeleton';
import {useLicenseCommonLimits} from 'src/hooks/dictionaries/useLicenseCommonLimits';

import {FormSection} from '@pb/kit-component-form-section';
import {Group, Item} from '@pb/kit-component-group';


export const LicenseUsageLimitsSkeleton = () => {
    const {licenseCommonLimits} = useLicenseCommonLimits();

    return (
        <FormSection
            headline="Usage Limits"
            info={() => (
                <Item grow={1}>
                    <Group justify="space-between" alignItems="center">
                        <SkeletonItem width={126} height={28}/>
                        <SkeletonItem width={54} height={18}/>
                    </Group>
                </Item>
            )}>
            <ResponsiveElementGroup>
                {licenseCommonLimits.map(({description, children}) => (
                    <Item key={description} className="pd-s">
                        <Group direction="v" alignItems="start">
                            <SkeletonItem width={118} height={18}/>
                            {children?.map(limit => (
                                <Group key={limit.code} direction="v" gap="xs" alignItems="start">
                                    <Item>
                                        <SkeletonItem width={60} height={18}/>
                                    </Item>
                                    <SkeletonItem width={140} height={32}/>
                                </Group>
                            ))}
                        </Group>
                    </Item>
                ))}
            </ResponsiveElementGroup>
        </FormSection>
    );
};
